import { Text, VStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { Logo } from '../../../../../packages/ui/components/atoms/Logo';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { ContactForm } from '../../../../../packages/ui/forms/ContactForm';
import { NotificationsForm } from '../../../../../packages/ui/forms/NotificationsForm';
import { ProfileForm } from '../../../../../packages/ui/forms/ProfileForm';
import { ProfileCard } from '../../components/organisms/ProfileCard';
import { MainTemplate } from '../../templates/MainTemplate';
import { ProfileLinks } from './components/Links';
import { Plans } from './components/Plans';
import { PlansIphone } from './components/PlansIphone';
import { DependentForm } from '../../../../../packages/ui/forms/DependentForm';

function ProfileSubPageTemplate({ children }: PropsWithChildren) {
  const { colors } = useTheme();

  return (
    <VStack spacing={5} width={'100%'}>
      {children}
      <Link to={'/perfil'}>
        <Text cursor={'pointer'} color={colors.primaryColor}>
          Voltar
        </Text>
      </Link>
    </VStack>
  );
}

export function ProfilePage() {
  const { isIOS } = useTheme();
  return (
    <MainTemplate hideTopMenu>
      <VStack
        spacing={5}
        width={{ base: '90%', lg: '500px' }}
        paddingTop={{ base: '10px', lg: '50px' }}
        paddingBottom={'100px'}
      >
        <Logo height={'90px'} objectFit={'contain'} w={'auto'} />
        <ProfileCard />

        <VStack backgroundColor={'#F5F5F5'} padding={'20px'} borderRadius={'20px'} width={'100%'}>
          <Routes>
            <Route path="/" element={<ProfileLinks />} />
            <Route
              path="/meus-dados"
              element={
                <ProfileSubPageTemplate>
                  <ProfileForm />
                </ProfileSubPageTemplate>
              }
            />
            <Route
              path="/notificacoes"
              element={
                <ProfileSubPageTemplate>
                  <NotificationsForm />
                </ProfileSubPageTemplate>
              }
            />
            <Route
              path="/dependentes"
              element={
                <ProfileSubPageTemplate>
                  <DependentForm />
                </ProfileSubPageTemplate>
              }
            />
            <Route
              path="/contato"
              element={
                <ProfileSubPageTemplate>
                  <ContactForm />
                </ProfileSubPageTemplate>
              }
            />
            <Route
              path="/planos/purchase-subscription-mobile/:token"
              element={<ProfileSubPageTemplate>{isIOS ? <PlansIphone /> : <Plans />}</ProfileSubPageTemplate>}
            />
          </Routes>
        </VStack>
      </VStack>
    </MainTemplate>
  );
}
